import SubMenu from 'common/navigation/components/sub-menu';
import MainMenu from 'common/navigation/containers/main-menu-container';
import Wrapper from 'common/navigation/wrapper';
import CreateOrders from 'order/create/containers/create-orders-container';
import PropTypes from 'prop-types';
import React from 'react';
import { isToggleEnabled } from 'react-awesome-feature-toggles';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { withRouter } from 'utils/withRouter';
import Info from './info/containers/info-container';
// import CreateOrders from 'order/create/containers/create-orders-container';
import { ticketObjectRoutes } from '../common/navigation/routes/cops-routes';
import TicketWorklistContainer from '../tickets/containers/list/ticket-worklist-container';
import { referenceTypes } from '../utils/app-configs';
import Dashboard from './components/dashboard';
import Timeline from './components/timeline';

const FunctionalLocation = ({ match }) => {
  const id = match.params.functionalLocationId;
  const renderMenu = actionButtons =>
    <MainMenu
      id={id}
      type={referenceTypes.functionallocation}
      actionButtons={actionButtons}
    >
      <SubMenu
        id={id}
        match={match}
        baseType={referenceTypes.functionallocation}
        hasTickets={isToggleEnabled('functionalLocationTicketFilter')}
        hasDashboard={isToggleEnabled('functionalLocationDashBoard')}
        base={`functionallocation/${id}`}
        extraLinks={isToggleEnabled('functionalLocationTimeLine') ?
          [
            {
              translationKey: 'nav.subNav.TIMELINE',
              uri: `/functionallocation/${id}/timeline`,
              absolute: true,
            },
          ] : []
        }
      />
    </MainMenu>;
  const ticketRoutes = ticketObjectRoutes();
  return (
    <Wrapper>
      <Routes>
        {isToggleEnabled('functionalLocationDashBoard') && <Route
          path={'dashboard/*'}
          element={<Dashboard id={id} renderMenu={renderMenu} />}
        />}
        <Route
          path={'info/*'}
          element={<Info id={id} renderMenu={renderMenu} />}
        />
        <Route
          path={'timeline/create-order/:type/:ids'}
          element={<>
            <Timeline
              id={id}
              renderMenu={renderMenu}
            />
            <CreateOrders />
          </>}
        />
        <Route
          path={'timeline/:jumpToDateOrFilter?/create-order/:type/:ids'}
          element={<>
            <Timeline
              id={id}
              renderMenu={renderMenu}
            />
            <CreateOrders />
          </>}
        />
        <Route
          path={'timeline/:jumpToDateOrFilter?/:filtervalue?/create-order/:type/:ids'}
          element={<>
            <Timeline
              id={id}
              renderMenu={renderMenu}
            />
            <CreateOrders />
          </>}
        />
        <Route
          path={'timeline/:jumpToDateOrFilter?/:filtervalue?'}
          element={<Timeline
            id={id}
            renderMenu={renderMenu}
          />
          }
        />
        {ticketRoutes?.map((r, i) => <Route
          path={`${r}/*`}
          key={i}
          element={
            <TicketWorklistContainer
              renderMenu={renderMenu}
              baseType={referenceTypes.functionallocation}
            />
          }
        />)}
        <Route
          path='/*'
          element={<Navigate
            to={isToggleEnabled('functionalLocationDashBoard') ? 'dashboard' : 'info'}
            replace
          />}
        />
      </Routes>
      <Outlet />
    </Wrapper>
  );
};

FunctionalLocation.propTypes = {
  match: PropTypes.object.isRequired,
};

export default withRouter(FunctionalLocation);
